
"use client"; 

import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext(undefined);


export const ThemeProvider = ({ children }) => {

  const [theme, setTheme] = useState('light'); 
  const applyThemeClass = useCallback((currentTheme) => {

    if (typeof document !== 'undefined') {
      const htmlElement = document.documentElement; 
      if (currentTheme === 'dark') {
        htmlElement.classList.add('dark-mode');
        htmlElement.classList.remove('light-mode');
      } else {
        htmlElement.classList.add('light-mode');
        htmlElement.classList.remove('dark-mode');
      }
    }
  }, []); 

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const savedTheme = localStorage.getItem('theme'); 

      if (savedTheme === 'dark' || savedTheme === 'light') {

        setTheme(savedTheme);
        applyThemeClass(savedTheme);
      } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
       
        setTheme('dark');
        applyThemeClass('dark');
      } else {
       
        setTheme('light');
        applyThemeClass('light');
      }
    }
  }, [applyThemeClass]);
 useEffect(() => {
    applyThemeClass(theme); 
    if (typeof window !== 'undefined') {
      localStorage.setItem('theme', theme); 
    }
  }, [theme, applyThemeClass]); 
// Function to toggle the theme between 'light' and 'dark'
  const toggleTheme = (x) => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // The value provided to the context consumers
  const contextValue = { theme, toggleTheme };

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to consume the theme context
// This makes it easier for components to access the theme and toggle function
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    // Throw an error if useTheme is called outside of a ThemeProvider
    // This helps catch common integration mistakes
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
